import { render, staticRenderFns } from "./CreateProductColors.vue?vue&type=template&id=43f1c37c&scoped=true"
import script from "./CreateProductColors.vue?vue&type=script&lang=js"
export * from "./CreateProductColors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f1c37c",
  null
  
)

export default component.exports